__turbopack_context__.v({
  "actions": "RSVPModal-module-scss-module__ZeN18q__actions",
  "attendanceOptionTitle": "RSVPModal-module-scss-module__ZeN18q__attendanceOptionTitle",
  "cancelButton": "RSVPModal-module-scss-module__ZeN18q__cancelButton",
  "content": "RSVPModal-module-scss-module__ZeN18q__content",
  "noteField": "RSVPModal-module-scss-module__ZeN18q__noteField",
});
